// extracted by mini-css-extract-plugin
export var altaccent = "MobileMenu-module--altaccent--1c66f";
export var aside = "MobileMenu-module--aside--ffdb6";
export var borderTop = "MobileMenu-module--border-top--1075a";
export var bounds = "MobileMenu-module--bounds--3f659";
export var button = "MobileMenu-module--button--55f44";
export var close = "MobileMenu-module--close--86bee";
export var group = "MobileMenu-module--group--0c55a";
export var heading = "MobileMenu-module--heading--8496d";
export var icon = "MobileMenu-module--icon--7ceae";
export var inactive = "MobileMenu-module--inactive--27d46";
export var item = "MobileMenu-module--item--7c3c9";
export var link = "MobileMenu-module--link--43815";
export var list = "MobileMenu-module--list--330b4";
export var logo = "MobileMenu-module--logo--1724e";
export var navigation = "MobileMenu-module--navigation--2033f";
export var open = "MobileMenu-module--open--0cf90";
export var scroll = "MobileMenu-module--scroll--c67dc";
export var subMenu = "MobileMenu-module--sub-menu--e6cf4";